import UmbracoImage from './UmbracoImage';

export default UmbracoImage;
